import { render, staticRenderFns } from "./SlidingBayDamageSeverity.vue?vue&type=template&id=c78a15f6&scoped=true"
import script from "./SlidingBayDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./SlidingBayDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78a15f6",
  null
  
)

export default component.exports